import { z } from 'zod';
import { validators } from '@huspy/forge/shared';
import i18n from 'i18next';

const { emailFieldValidator, textFieldValidator } = validators;

const isRequiredText = 'common.validation.requiredField';

export const emailSubmissionSchema = z.object({
  sendTo: z.array(emailFieldValidator).nonempty(i18n.t(isRequiredText)),
  subject: textFieldValidator,
  cc: z.array(emailFieldValidator),
  body: z.string(),
});
